import {
  countCompaniesByStatus,
  resolveEffectiveTab
} from '../model/companies-tabs'

/**
 * Companies-panel seam. Exposes the pure tab derivations (active/inactive counts
 * and the effective-tab fallback) so the panel reaches them without
 * value-importing `model/` (the MVVM no-restricted-imports rule on model/).
 */
export function useCompaniesPanel() {
  return { countCompaniesByStatus, resolveEffectiveTab }
}
